<template>
    <div class="tabs-demo1 ">
        <div class="filterBox">
            <filter-box ref="filterBox" @search="search" @emptySearch="emptySearch"></filter-box>
        </div>
        <vx-card title="">
            <div class="mt-5 orderbox">
                <clients-list-table ref="listTable" />
            </div>
        </vx-card>

    </div>
</template>

<script>
    import filterBox from "./filterBox";
    import ClientsListTable from "./tableList.vue";
    export default {
        components: {
            ClientsListTable,
            filterBox
        },
        data () {
            return {


                loaded: false
            }
        },
        computed: {
        },
        methods: {
            search(selectTJ){
                console.log(selectTJ,"筛选条件")
                this.$refs.listTable.getSelect(selectTJ)
            },
            emptySearch(){
                this.$refs.listTable.getEmptySearch()
            }
        },
        created() {
        }
    }
</script>
<style lang="scss" scoped>

    .tabs-demo1{
        display: flex;
        width:100%;
        .filterBox{
            width: 246px !important;
            margin-right:20px;
            background-color: #fff;
            border-radius: 4px;
        }
        .vx-card{
            /* flex:1; */
            width: 80% !important;
        }
    }
</style>
